export default __webpack_public_path__ + "static/media/whitepaper.b38f11fb.png";